/**
 * Formatters for cache-convergence run rows shown in the Flow Designer's
 * Runs tab. A convergence run has no pass/fail counts — it advances through
 * `preflight → fork → converge → verify → promote → origin_gate → finalize`
 * and is judged by `outcome`, not the raw `status`.
 */

/**
 * `converged`/`merged` read as success, `awaiting_review` and
 * `partially_converged` as a warning/attention state, and
 * `unverified`/`blocked`/`error` as failure.
 */
export const CONVERGENCE_OUTCOME_VARIANTS: Record<string, 'success' | 'warning' | 'destructive'> =
  {
    converged: 'success',
    merged: 'success',
    awaiting_review: 'warning',
    partially_converged: 'warning',
    unverified: 'destructive',
    blocked: 'destructive',
    error: 'destructive',
  };

export function formatConvergenceLabel(value: string): string {
  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatConvergenceProgress(
  phase: string,
  cycleCount: number,
  cycleCap: number | null
): string {
  return `${formatConvergenceLabel(phase)} · ${formatConvergenceProofAttempts(cycleCount, cycleCap)}`;
}

export function formatConvergenceProofAttempts(
  cycleCount: number,
  cycleCap: number | null
): string {
  return cycleCap === null
    ? `Proof attempts: ${cycleCount}`
    : `Proof attempts: ${cycleCount}/${cycleCap}`;
}
